// extracted by mini-css-extract-plugin
module.exports = {"dashboardContent":"_2XjVY__dashboardContent","contentSection":"_2XFkR__contentSection"};